module.exports = __webpack_public_path__ + "static/media/profile.cd25ac23.JPG";